import './MultiValueOverflow.style.less'
import { Popover, Typography } from 'antd'
import { isEmptyValue } from '@/utils/common'

const { Paragraph } = Typography

type Props = {
  items: string[]
  title: string
  maxVisible?: number
}

function MultiValueOverflow({ items, title, maxVisible = 2 }: Props) {
  const validItems = (items ?? []).filter((item) => !isEmptyValue(item))

  if (isEmptyValue(validItems)) {
    return <Paragraph style={{ margin: 0 }}>-</Paragraph>
  }

  const visibleItems = validItems.slice(0, maxVisible)
  const restCount = validItems.length - visibleItems.length

  return (
    <Paragraph style={{ margin: 0 }}>
      {visibleItems.join(', ')}
      {restCount > 0 && (
        <Popover
          trigger="hover"
          placement="bottomLeft"
          overlayClassName="multi-value-overflow-popover"
          content={
            <div className="multi-value-overflow-popover-content">
              <div className="multi-value-overflow-popover-title">
                {title} ({validItems.length})
              </div>
              <div className="multi-value-overflow-popover-list">
                {validItems.map((item, index) => (
                  <div className="multi-value-overflow-popover-item" key={index}>
                    {item}
                  </div>
                ))}
              </div>
            </div>
          }
        >
          <span className="multi-value-overflow-badge">+{restCount}</span>
        </Popover>
      )}
    </Paragraph>
  )
}

export default MultiValueOverflow
